import type { Area, Level } from "@/lib/permissions";
import { createContext, useContext } from "react";

interface AreaContextValue {
  area: Area | null;
  level: Level;
}

// Ungated screens (the ones on public /v1 routes) behave as full access.
const AreaContext = createContext<AreaContextValue>({
  area: null,
  level: "write",
});

export const AreaProvider = AreaContext.Provider;

export const useArea = () => useContext(AreaContext);

/** True when the current screen may run creates, edits, deletes, grants or sends. */
export const useCanWriteHere = () => useContext(AreaContext).level === "write";

/** True when the screen is open but every write control has to be locked. */
export const useIsReadOnlyHere = () => useContext(AreaContext).level === "read";
